import React from 'react'
import { useKaipiaolxDelMutation } from '../../../store/DianShangYeWuApi'
import Icon from '../../../cpn/Icon';
import { App } from 'antd'
function InvoiceTypeDel(props) {
    const {message} = App.useApp()
    const [submitDel] = useKaipiaolxDelMutation()        
    return (
        <Icon type='delete' 
            onClick={() => {
                submitDel({
                    kplx_id:props.kplx_id,
                }).then((res) => {
                    if (res.data.Status === 'success') {
                        message.info('删除成功');
                    }
                    if (res.data.Status === "fail") {
                        message.error('删除失败：'+res.data.Message)
                    }
                })
            }}
        > </Icon>
    )
    }

export default InvoiceTypeDel